import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldviewRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldview',
	path: '/secure/admin/ViewIssueFields.jspa',
};
